import { isValidPhoneNumber } from "libphonenumber-js"

const calendarDate = (value) => (value ? value.slice(0, 10) : null)

const evaluateExpiry = (
  expirationDate,
  quote,
  fieldKey,
  messages,
  warnings
) => {
  const expiry = calendarDate(expirationDate)
  if (!expiry) return
  if (expiry < quote.marinaToday) {
    messages[fieldKey] = quote.wizardCopy.coverageExpired
  } else if (quote.contractStartDate && expiry < quote.contractStartDate) {
    warnings[fieldKey] = quote.wizardCopy.expiresBeforeStart
  }
}

export const evaluatePhone = (state, quote) => {
  const { phone } = state.requiredInformation

  if (!quote.phoneInvalid || isValidPhoneNumber(phone || "", "US")) {
    return { valid: true, message: null }
  }

  return {
    valid: false,
    message: phone ? quote.wizardCopy.invalidPhone : null,
  }
}

export const evaluateRequiredStep = (
  state,
  quote,
  { includePhone = true } = {}
) => {
  const { registration, insurance } = state.requiredInformation
  const {
    registrationRequired,
    insuranceRequired,
    insuranceRequirement,
    registrationRequirement,
    wizardCopy,
  } = quote

  const messages = {}
  const warnings = {}
  let valid = true

  if (includePhone) {
    const phone = evaluatePhone(state, quote)
    if (!phone.valid) valid = false
    if (phone.message) messages.phone = phone.message
  }

  if (insuranceRequired) {
    if (insurance.companyName === "") valid = false
    if (insurance.policyNumber === "") valid = false
    if (insurance.expirationDate === null) valid = false
    evaluateExpiry(
      insurance.expirationDate,
      quote,
      "insurance.expirationDate",
      messages,
      warnings
    )
    if (messages["insurance.expirationDate"]) valid = false

    if (insuranceRequirement === "info_and_upload") {
      if (insurance.documentError) {
        valid = false
        messages["insurance.document"] = insurance.documentError
      } else if (insurance.replacingDocument && insurance.document !== true) {
        valid = false
        messages["insurance.document"] = wizardCopy.attachOrKeepDocument
      } else if (
        insurance.document !== true &&
        insurance.existingDocument === null
      ) {
        valid = false
        messages["insurance.document"] = wizardCopy.attachInsuranceDocument
      }
    }
  }

  if (registrationRequired) {
    if (registration.registrationNumber === "") valid = false
    if (registration.expirationDate === null) valid = false
    evaluateExpiry(
      registration.expirationDate,
      quote,
      "registration.expirationDate",
      messages,
      warnings
    )
    if (messages["registration.expirationDate"]) valid = false

    if (registrationRequirement === "info_and_upload") {
      if (registration.documentError) {
        valid = false
        messages["registration.document"] = registration.documentError
      } else if (
        registration.replacingDocument &&
        registration.document !== true
      ) {
        valid = false
        messages["registration.document"] = wizardCopy.attachOrKeepDocument
      } else if (
        registration.document !== true &&
        registration.existingDocument === null
      ) {
        valid = false
        messages["registration.document"] =
          wizardCopy.attachRegistrationDocument
      }
    }
  }

  return { valid, messages, warnings }
}
